<adapt-feature-guidance [configItem]="configItem">
    <p>In a team, to enable effective stewardship, the work of the team should be tracked. The actions feature inside the platform allows
        you to visualise and track actions within a team.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem"> </adapt-feature-configuration>
